export default "__VITE_PUBLIC_ASSET__fb412c76__"